<template>
  <v-expansion-panel>
    <v-expansion-panel-header hide-actions :style="{ 'background-color': level === 2 ? '#f7f7f7' : 'white' }">
      <template #default="{open}">
        <v-row no-gutters class="align-center mx-3">
          <v-col cols="5">
            <v-row no-gutters>
              <v-col cols="auto">
                <v-icon v-if="!open" size="20px">
                  mdi-menu-right
                </v-icon>
                <v-icon v-else size="20px">
                  mdi-menu-down
                </v-icon>
              </v-col>
              <v-col cols="5">
                <span class="text-body-2">
                  {{ header }}
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="7" v-if="level === 2 && items.length > 0">
            <v-row no-gutters>
              <v-col cols="6">
                <div :style="{ width: '150px', margin: 'auto' }">
                  <permissions-select
                    v-model="computedPermissionValue"
                    :permission-levels="items.every(item => item.type === 'service_layer') ? 'two' : 'three'"
                  />
                </div>
              </v-col>
              <v-col cols="6" align-self="center" class="pl-1">
                <div :style="{ width: '0px', margin: 'auto' }">
                  <permissions-checkbox
                    :disabled="computedPermissionValue === 0"
                    v-model="computedAttachmentsCommentsValue"
                  />
                </div>
              </v-col>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot name="content"> </slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { get } from 'vuex-pathify';
import PermissionsSelect from '@/components/PermissionsSelect';
import PermissionsCheckbox from '@/components/PermissionsCheckbox';
export default {
  name: 'PermissionsExpansionPanel',
  components: {
    PermissionsSelect,
    PermissionsCheckbox,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    level: {
      type: Number,
    },
    items: {
      type: Array,
    },
  },
  computed: {
    currentGroupPermissions: get('users/currentGroupPermissions'),
    computedAttachmentsCommentsValue: {
      get() {
        const featuresLayers = this.items.filter(item => item.type === 'features_layer');
        let featuresLayersValue =
          featuresLayers.length > 0 ? this.getPermission(featuresLayers[0].id, 'attachments_and_comments_value') : 0;
        for (const layer of featuresLayers) {
          if (featuresLayersValue !== this.getPermission(layer.id, 'attachments_and_comments_value')) {
            featuresLayersValue = 0;
            break;
          }
        }
        return featuresLayersValue;
      },
      set(nV) {
        this.$emit('updateAttachmentsCommentsValue', nV);
      },
    },
    computedPermissionValue: {
      get() {
        const featuresLayers = this.items.filter(item => item.type === 'features_layer');
        const servicesLayers = this.items.filter(item => item.type !== 'features_layer');

        let featuresLayersValue =
          featuresLayers.length > 0 ? this.getPermission(featuresLayers[0].id, 'main_value') : null;
        for (const layer of featuresLayers) {
          if (featuresLayersValue !== this.getPermission(layer.id, 'main_value')) {
            featuresLayersValue = null;
            break;
          }
        }

        let servicesLayersValue =
          servicesLayers.length > 0 ? this.getPermission(servicesLayers[0].id, 'main_value') : null;
        for (const layer of servicesLayers) {
          if (servicesLayersValue !== this.getPermission(layer.id, 'main_value')) {
            servicesLayersValue = null;
            break;
          }
        }
        if (featuresLayers.length < 1 && servicesLayers.length > 0) {
          return servicesLayersValue;
        } else if (featuresLayers.length > 0 && servicesLayers.length < 1) {
          return featuresLayersValue;
        } else if (featuresLayersValue === 0 && servicesLayersValue === 0) {
          return 0;
        } else if (featuresLayersValue === 1 && servicesLayersValue === 1) {
          return 1;
        } else if (featuresLayersValue === 2 && servicesLayersValue === 1) {
          return 2;
        }
        return null;
      },
      set(nV) {
        this.$emit('updatePermissionsValue', nV);
      },
    },
  },
  methods: {
    getPermission(id, key) {
      return this.currentGroupPermissions['layers'].find(permission => permission['layer_id'] === id)[key];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-expansion-panel-header::before {
    background-color: white;
  }
}
</style>
